import * as React from 'react'

import { Box, BoxList, Button, Link, Text } from '@factorialco/deprecated-design-system'
import { AtsGetJobPostingSettingsEvaluationFormsDocument } from 'generated/resources/graphql'

import { useEffect } from 'modules/core/hooks/useEffect'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { AddEvaluationForm } from './AddEvaluationForm'
import { EvaluationFormsItem } from './EvaluationFormsItem'
import { EvaluationFormsSkeleton } from './EvaluationFormsSkeleton'

interface Props {
  jobId: number
}

export const EvaluationForms = ({ jobId }: Props) => {
  const [addEvaluationFormOpen, setAddEvaluationFormOpen] = React.useState(false)

  const { data, loading } = useQuery(AtsGetJobPostingSettingsEvaluationFormsDocument, {
    variables: {
      id: jobId,
    },
  })

  useEffect(() => {
    track(trackingEvents.ats.jobSettingsAccessEvaluationForm)
  }, [])

  const evaluationForms = data?.ats.evaluationFormsConnection.nodes

  if (loading || !evaluationForms) {
    return <EvaluationFormsSkeleton />
  }

  return (
    <>
      <Box gap="s8">
        <Text size="400" color="grey1000" weight="semibold">
          {i18n.t('ats.job_posting_settings.evaluation_forms.title')}
        </Text>
        <Text size="300" color="grey800">
          {i18n.t('ats.job_posting_settings.evaluation_forms.description')}
        </Text>
        <Link.Href target="_blank" rel="noreferrer" href="#">
          {i18n.t('common.learn_more')}
        </Link.Href>
        <Box paddingTop="s8">
          <Button onClick={() => setAddEvaluationFormOpen(true)} iconName="add" type="secondary">
            {i18n.t('common.add')}
          </Button>
        </Box>
      </Box>

      <Box paddingTop="s40" gap="s16">
        <BoxList>
          {!evaluationForms.length && (
            <Box background="grey000White" justifyContent="center" width="full" padding="s32">
              <Text.Normal weight="medium">
                {i18n.t('ats.job_posting_settings.evaluation_forms.empty_list')}
              </Text.Normal>
            </Box>
          )}

          {evaluationForms.map((item, index) => (
            <EvaluationFormsItem key={index} item={item} />
          ))}
        </BoxList>
      </Box>

      {addEvaluationFormOpen && (
        <AddEvaluationForm jobId={jobId} onClose={() => setAddEvaluationFormOpen(false)} />
      )}
    </>
  )
}
